export default {
  'statusCodes.Status_code': '狀態碼',
  'statusCodes.Total': '總計',
  'statusCodes.title': '狀態碼報告',
  'statusCodes.subTitle': '（請按照utc+8的時區查看數據。）',
  'statusCodes.Request': '請求',
};
